import { render, staticRenderFns } from "./MerchantResources.vue?vue&type=template&id=8604969c&scoped=true&"
import script from "./MerchantResources.vue?vue&type=script&lang=js&"
export * from "./MerchantResources.vue?vue&type=script&lang=js&"
import style0 from "./MerchantResources.vue?vue&type=style&index=0&id=8604969c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8604969c",
  null
  
)

export default component.exports